import { Button, Heading, Icon, IconButton, Select, SimpleGrid, Stack, StackDivider, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useState } from "react";
import { BsGearFill } from "react-icons/bs";
import { FaArrowLeft, FaArrowRight, FaHistory, FaTrash } from "react-icons/fa";
import { GrSync } from "react-icons/gr";

export default function InProcess() {
    const [items] = useState([
        {
            id: 1,
            name: "Star Trek Voucher😂"
        },
        {
            id: 2,
            name: "Inam Neil Degrasse Tyson Voucher"
        },
        {
            id: 3,
            name: "Bank Payment Voucher",
        },
        {
            id: 4,
            name: "Cigarette Expense Voucher",
        },
        {
            id: 5,
            name: "Purchase Invoice",
        },
        {
            id: 6,
            name: "Refund Document",
        },
    ]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'column', "2xl": "row" }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 6, "2xl": 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={GrSync}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>In Process</Heading>
                            <Text fontSize={'sm'}>You can review all documents in process here.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', "2xl": 'flex-end' }} direction={'row'} spacing={4}>
                    {/* <InputGroup>
                        <Input placeholder='Search' />
                        <InputRightElement zIndex={0} children={<FaSearch color={'rgba(0,0,0,0.19)'} />} />
                    </InputGroup> */}
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <SimpleGrid
                    templateColumns={{ base: '1fr', md: '1fr 4fr 2fr' }}
                    spacing={6}
                >
                    <Stack>
                        <Select
                            w={'full'}
                            size={'sm'}
                        >
                            <option value={'option1'}>All Documents</option>
                            <option value={'option1'}>Invoices & Receipts</option>
                            <option value={'option1'}>Bank Statements</option>
                            <option value={'option1'}>Other Documents</option>
                        </Select>
                        <Stack
                            w={'full'}
                            direction={'row'}
                            justify={'space-between'}
                        >
                            <Button
                                leftIcon={<FaTrash />}
                                color={'white'}
                                bg={'red.400'}
                                _hover={{ bg: 'red.500' }}
                                _active={{ bg: 'red.600' }}
                                size={'sm'}
                            >
                                Delete
                            </Button>

                            <IconButton
                                aria-label="Previous"
                                icon={<BsGearFill />}
                                size={'sm'}
                                colorScheme={'gray'}
                            />
                        </Stack>
                        <TableContainer>
                            <Table size='sm'>
                                <Thead h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                                    <Tr>
                                        <Th
                                            color={'white'}
                                            isNumeric
                                        >
                                            ID
                                        </Th>
                                        <Th
                                            color={'white'}
                                        >
                                            Name
                                        </Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        items.map(item => (
                                            <Tr>
                                                <Td
                                                    isNumeric
                                                >
                                                    {item.id}
                                                </Td>
                                                <Td>
                                                    {item.name}
                                                </Td>
                                            </Tr>
                                        ))
                                    }
                                    {/* <Tr>
                                        <Td colSpan={2} textAlign={'center'}>There is no document in this folder</Td>
                                    </Tr> */}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Stack>
                    <Stack>
                        <Stack w={'full'} h={'full'} align={'center'} justify={'center'} textAlign={'center'} bg={'gray.500'}>
                            <Heading color={'white'}>PDF Viewer Here</Heading>
                            <Text color={'whiteAlpha.900'}>I'm currently thinking about creating a dynamic method <br /> for PDFs and Document Viewer <br /> I'll update the document viewer once, I find a solution for that</Text>
                        </Stack>
                    </Stack>
                    <Stack w={'full'} spacing={6} divider={<StackDivider />}>
                        <Stack direction={'row'} justify={'space-between'} align={'center'}>
                            <Stack direction={'row'}>
                                <IconButton
                                    aria-label="Previous"
                                    icon={<FaArrowLeft />}
                                    rounded={'full'}
                                    size={'sm'}
                                    colorScheme={'orange'}
                                />
                                <IconButton
                                    aria-label="Previous"
                                    icon={<FaArrowRight />}
                                    rounded={'full'}
                                    size={'sm'}
                                    colorScheme={'orange'}
                                />
                            </Stack>
                            <Stack direction={'row'}>
                                <Button
                                    leftIcon={<FaHistory />}
                                    color={'white'}
                                    bg={'primary.400'}
                                    _hover={{ bg: 'primary.400' }}
                                    _active={{ bg: 'primary.400' }}
                                    size={'sm'}
                                >
                                    History
                                </Button>
                            </Stack>
                        </Stack>
                        <Stack spacing={4}>
                            <Heading fontSize={'lg'}>Document Properties</Heading>
                            <Text>Uploaded Date: <strong>17/11/2022</strong></Text>
                            <Text>Document Type: <strong>Statement</strong></Text>
                            <Text>Status: <strong>Extracted Part</strong></Text>
                            <Text>Uploaded By: <strong>Hamza EB</strong></Text>
                            <Text>Document Id: <strong>24683-Statement</strong></Text>
                            <Text>File Last Saved By: <strong>Hamza EB</strong></Text>
                            <Text>File Size: <strong>66196 Bytes</strong></Text>
                            <Text>File Last Saved Date: <strong>19/11/2022 12:00:00 A.M.</strong></Text>
                        </Stack>
                    </Stack>
                </SimpleGrid>
            </Stack>
        </Stack >
    )
}